import { render, staticRenderFns } from "./MultimediaTab.vue?vue&type=template&id=76ea9b4e&"
import script from "./MultimediaTab.vue?vue&type=script&lang=js&"
export * from "./MultimediaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports